if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

addEventListener("DOMContentLoaded", (event) => {
    (function(){
        function split( val ) {
            return val.split( /,\s*/ );
        }
        function extractLast( term ) {
            return split( term ).pop();
        }
        $( "#question" ).autocomplete({
            source: function( request, response ) {
                $.ajax( {
                  url: "ajax/functions.php",
                  dataType: "json",
                  data: {
                    term: request.term,
                    operation: "googleCustomSearch"
                  },
                  success: function( data ) {
                    response(data.items)
                  }
                });
            },
            messages: {
                noResults: 'No results.',
                results: function(amount) {
                    return amount + ' Results.'
                }
            },
            minLength: 2,
            select: function( event, ui ) {
                event.preventDefault()
                console.log(ui.item.value)
                window.location.href = ui.item.value
            }
        });
    
        // Remove empty <p> tags created by tinymce
        const paragraph = document.querySelectorAll('p') || [];
        paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));
    
    
        $('#menu-btn').click(function(event) {
            $('#navigation').addClass('open');
        });
    
        $('.close-menu').click(function(event) {
            event.preventDefault();
            $('#navigation').removeClass('open');
        });
    
    
        $('.sym-slides').slick({
            accessibility: false,
            pauseOnHover : false
        });

        $('.news-slides').slick({
            accessibility: false,
            pauseOnHover : false
        });        
        
        $('.slider-for-accomodations').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            fade: true,
            asNavFor: '.slider-nav-accomodations',
            responsive: [
                {
                    breakpoint: 480,
                    settings: {
                        arrows: true,
                        dots: false,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        infinite: true
                    }
                }
            ]
        });
    
        $('.slider-nav-accomodations').slick({
            slidesToShow: 4,
            slidesToScroll: 1,
            arrows: true,
            responsive: [
                {
                    breakpoint: 480,
                    settings: {
                        arrows: true,
                        dots: false,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        infinite: true
                    }
                }
            ]
        });
    
        $('.images-slides').slick({
            arrows: true,
            dots: false,
            infinite: true,
            autoplay: false,
            autoplaySpeed: 3000,
            speed: 1000,
            fade: true,
            accessibility: false
        });
    
        $('.carousel-slider').slick({
            arrows: false,
            dots: false,
            infinite: false,
            speed: 300,
            slidesToShow: 3,
            slidesToScroll: 1,
            accessibility: false,
            responsive: [
                {
                    breakpoint: 600,
                    settings: {
                        arrows: true,
                        dots: false,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        infinite: false,
                        adaptiveHeight: true
                    }
                }
            ]
        });
    
        $('.slider-bg-slider').slick({
            arrows: false,
            dots: false,
            infinite: true,
            speed: 500,
            fade: true,
            cssEase: 'linear',
            accessibility: false
        });
    
        $('.slider-info-slides').slick({
            arrows: false,
            dots: true,
            infinite: true,
            speed: 500,
            fade: true,
            cssEase: 'linear',
            accessibility: false,
            responsive: [
                {
                    breakpoint: 600,
                    settings: {
                        adaptiveHeight: true
                    }
                }
            ]
        });
    
        $('.gallery-content').slick({
            arrows: true,
            dots: false,
            infinite: true,
            autoplay: false,
            autoplaySpeed: 3000,
            speed: 500,
            slidesToShow: 4,
            slidesToScroll: 1,
            accessibility: false,
            responsive: [
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                    }
                }
            ]
        });
    
        var linksAnchors = $('.list-block a.btn[href*="#"]:not([href="#"]');
    
        $(linksAnchors).click(function(event) {
            event.preventDefault();
            animateto(this.getAttribute('href').split('#')[1]);
        });
    
    })();

    (function(){
        function split( val ) {
            return val.split( /,\s*/ );
        }
        function extractLast( term ) {
            return split( term ).pop();
        }
        $( "#question" ).autocomplete({
            source: function( request, response ) {
                $.ajax( {
                  url: "ajax/functions.php",
                  dataType: "json",
                  data: {
                    term: request.term,
                    operation: "googleCustomSearch"
                  },
                  success: function( data ) {
                    response(data.items)
                  }
                });
            },
            messages: {
                noResults: 'No results.',
                results: function(amount) {
                    return amount + ' Results.'
                }
            },
            minLength: 2,
            select: function( event, ui ) {
                event.preventDefault()
                console.log(ui.item.value)
                window.location.href = ui.item.value
            }
        });
    
        // Remove empty <p> tags created by tinymce
        const paragraph = document.querySelectorAll('p') || [];
        paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));
    
    
        $('#menu-btn').click(function(event) {
            $('#navigation').addClass('open');
        });
    
        $('.close-menu').click(function(event) {
            event.preventDefault();
            $('#navigation').removeClass('open');
        });
    
    
        $('.sym-slides').slick({
            accessibility: false,
            pauseOnHover : false
        });
        
        $('.slider-for-accomodations').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            fade: true,
            asNavFor: '.slider-nav-accomodations',
            responsive: [
                {
                    breakpoint: 480,
                    settings: {
                        arrows: true,
                        dots: false,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        infinite: true
                    }
                }
            ]
        });
    
        $('.slider-nav-accomodations').slick({
            slidesToShow: 4,
            slidesToScroll: 1,
            arrows: true,
            responsive: [
                {
                    breakpoint: 480,
                    settings: {
                        arrows: true,
                        dots: false,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        infinite: true
                    }
                }
            ]
        });
    
        $('.images-slides').slick({
            arrows: true,
            dots: false,
            infinite: true,
            autoplay: false,
            autoplaySpeed: 3000,
            speed: 1000,
            fade: true,
            accessibility: false
        });
    
        $('.carousel-slider').slick({
            arrows: false,
            dots: true,
            infinite: false,
            speed: 300,
            slidesToShow: 3,
            slidesToScroll: 1,
            accessibility: false,
            responsive: [
                {
                    breakpoint: 600,
                    settings: {
                        arrows: true,
                        dots: false,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        infinite: false,
                        adaptiveHeight: true
                    }
                }
            ]
        });
    
        $('.slider-bg-slider').slick({
            arrows: false,
            dots: false,
            infinite: true,
            speed: 500,
            fade: true,
            cssEase: 'linear',
            accessibility: false
        });
    
        $('.slider-info-slides').slick({
            arrows: false,
            dots: true,
            infinite: true,
            speed: 500,
            fade: true,
            cssEase: 'linear',
            accessibility: false,
            responsive: [
                {
                    breakpoint: 600,
                    settings: {
                        adaptiveHeight: true
                    }
                }
            ]
        });
    
        $('.gallery-content').slick({
            arrows: true,
            dots: false,
            infinite: true,
            autoplay: false,
            autoplaySpeed: 3000,
            speed: 500,
            slidesToShow: 4,
            slidesToScroll: 1,
            accessibility: false,
            responsive: [
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                    }
                }
            ]
        });
    
        var linksAnchors = $('.list-block a.btn[href*="#"]:not([href="#"]');
    
        $(linksAnchors).click(function(event) {
            event.preventDefault();
            animateto(this.getAttribute('href').split('#')[1]);
        });
    
    })();
});






function animateto(target){
    var gotoTarget = offset(document.getElementById(target)).top - 180;
    var from     = window.pageYOffset
    var to       = gotoTarget
    var duration = 1300;
    var start = new Date().getTime()

    //time interval
    var timer = setInterval(function() {
        var time = new Date().getTime() - start;

        if(from <= to ){
            var y = easeInOutQuart(time, from, to - from, duration);
        } else {

            var y = easeInOutQuart(time, from, -(from - to), duration);
        }
        window.scrollTo(0, y)
        if (time >= duration) clearInterval(timer);

    }, 1000 / 60);

    window.scrollTo(0, from)

}
//ease movement
function easeInOutQuart(t, b, c, d) {
    if ((t /= d / 2) < 1) return c / 2 * t * t * t * t + b;
    return -c / 2 * ((t -= 2) * t * t * t - 2) + b;
}
function offset(el) {
    var rect = el.getBoundingClientRect(),
        scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
        scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
}